import { makeStyles } from 'tss-react/mui';

const fixedContainer = (width, height) => ({
  minWidth: width,
  maxWidth: width,
  minHeight: height ? height : width,
  maxHeight: height ? height : width,
});

const fitImage = (width, height) => ({
  maxWidth: width,
  maxHeight: height ? height : width,
});

export const unsetHeightAndWidth = () => ({
  height: 'unset',
  width: 'unset',
});

export const useStyles = makeStyles()((theme, { imageContainer } = {}) => ({
  hidden: { display: 'none' },
  container:
    (imageContainer && {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      ...fixedContainer(...imageContainer.desktop),
      [theme.breakpoints.down('lg')]: {
        ...fixedContainer(...imageContainer.tablet),
      },
      [theme.breakpoints.down('md')]: {
        ...fixedContainer(...imageContainer.mobile),
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...(theme.isMobileDevice && {
          ...fixedContainer(...imageContainer.tablet),
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          ...fixedContainer(...imageContainer.mobile),
        }),
      },
      '& img': {
        ...unsetHeightAndWidth(),
        ...fitImage(...imageContainer.desktop),
        [theme.breakpoints.down('lg')]: {
          ...fitImage(...imageContainer.tablet),
        },
        [theme.breakpoints.down('md')]: {
          ...fitImage(...imageContainer.mobile),
        },
        [theme.breakpoints.downLandscape('lg')]: {
          ...(theme.isMobileDevice && {
            ...fitImage(...imageContainer.tablet),
          }),
        },
        [theme.breakpoints.downLandscape('md')]: {
          ...(theme.isMobileDevice && {
            ...fitImage(...imageContainer.mobile),
          }),
        },
      },
    }) ||
    {},
  text: {
    alignItems: 'center',
    display: 'flex',
    fontSize: 14,
    fontWeight: 600,
    justifyContent: 'center',
    minHeight: '100%',
    minWidth: '100%',
    [theme.breakpoints.down('md')]: {
      fontSize: 12,
    },
  },
}));
